import { render, staticRenderFns } from "./OrderSelection.vue?vue&type=template&id=2d0e6d60&scoped=true&"
import script from "./OrderSelection.vue?vue&type=script&lang=js&"
export * from "./OrderSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e6d60",
  null
  
)

export default component.exports